import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { fetchKajeReturnReg2 } from '../../../Store/PHPSlice/Kaje/KajeApi';
import axios from 'axios';

const TableBody = ({
    serialNumber,
    id,
    dt,
    kreMemo,
    kjMemo,
    kId,
    firmId,
    firmNm,
    soId,
    sono,
    orderno,
    empId,
    empNm,
    itemId,
    itemNm,
    totqty,
    inwqty,
    sts,
    tsts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("Are you sure you want to delete this Kaje Inward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteKajeInward(id)
        }
    };

    const deleteKajeInward = async (id) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteKajeInwardReg&kinwId=${id}`);
            // console.log(res);
            const msg = res?.data;
            alert(msg.msg);
            dispatch(fetchKajeReturnReg2());
        } catch (error) {
            console.error("Error deleting Item:", error);
        }
    };

    const handleViewClick = () => {
        window.open(`/Kaje-Inw-Info/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };



    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const handleReturnClick = () => {
        window.open(`/Kaje-return/${id}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {kreMemo}
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {kjMemo}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {inwqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button variant="contained" color="primary" onClick={handleReturnClick} disabled={sts === '1'}>Return</Button>
                </TableCell> */}

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${tsts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick}/>
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
